// extracted by mini-css-extract-plugin
export default {"wrapper":"RoomTabMinimal_wrapper__-uKT5","header":"RoomTabMinimal_header__ymr5s"};